import PropTypes from 'prop-types'
import { toast } from 'react-toastify'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Input from '../../../../../common/form/Input'
import SubmitButton from '../../../../../common/buttons/SubmitButton'

import { inviteStudentToProgram } from '../../../../../../actions/waitlistActions'

import classes from './InviteToRegisterForm.module.scss'

const InviteToRegisterForm = ({ course, waitlistEntry, closeModal }) => {
  const dispatch = useDispatch()
  const isLoading = useSelector(state => state.waitlist.isLoading)
  const [coachMessage, setCoachMessage] = useState('')

  const handleInviteStudent = () => {
    dispatch(inviteStudentToProgram({ course, waitlistEntry, coachMessage }))
      .unwrap()
      .catch(() => toast.error('Something went wrong.', { position: toast.POSITION.TOP_RIGHT }))
      .finally(() => closeModal())
  }

  return (
    <>
      <div className='d-flex flex-column justify-content-center'>
        <Input
          name='description'
          type='textarea'
          onChange={(e) => setCoachMessage(e.target.value)}
          placeholder='Insert your message to golfers here (optional)'
          value={coachMessage}
          classNames={{
            inputContainer: classes.coachMessageInputContainer,
            inputContainerWrapper: 'mt-2',
          }}
        />
      </div>
      <div>
        <div className='row py-3 justify-content-center align-items-center'>
          <div className='col-12'>
            <SubmitButton
              onClick={handleInviteStudent}
              buttonMessage='Invite To Register'
              buttonColor='orange-button'
              loading={isLoading}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </>
  )
}

InviteToRegisterForm.propTypes = {
  course: PropTypes.shape({ id: PropTypes.number }),
  waitlistEntry: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  closeModal: PropTypes.func,
}

export default InviteToRegisterForm
